export const formatBreadcrumbTitle = (title: string | undefined): string =>
  title?.replace("|", " ") ?? "";
